<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Get Student Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Select Academic Year"
            outlined
            persistent-hint
            hint="Please select academic year"
            @change="getStud()"
            @click="show = false"
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            v-model="registration_no"
            rounded
            color="#0F2027"
            :items="stud_list"
            label="Select Student"
            item-text="name"
            return-object
            @change="addtomarksheet()"
            outlined
            dense
            @click="show = false"
            persistent-hint
            hint="Please select Student"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no">
          <v-btn class="mt-6 button" @click="getreport()"
            >Fetch / Generate</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <!-- <span v-if="show == true">
            <learner-marksheet-info></learner-marksheet-info>
        </span> -->
  </div>
</template>
<script>
import axios from "axios";
import LearnerMarksheetInfo from "./LearnerMarksheetInfo";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    "learner-marksheet-info": LearnerMarksheetInfo,
  },
  data() {
    return {
      default_value: [],
      dialog_marks: false,
      overlay: false,
      selected: [],
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      semester_list: null,
      sem: null,
      fetch_loader: false,
      show: false,
      course_list: [],
      stud_list: [],
      awspath: "",
      registration_no: null,
      standard: null,
      div: null,
      ay: null,
      name: null,
      dob: null,
      roll_no: null,
      mobile_no: null,
      address: null,
      mother_name: null,
      photo: null,
      reg_no: null,
      father_full_name: null,
      leraner_marksheet: [],
      colspan: null,
    };
  },

  methods: {
    putnull3() {
      this.show = false;
    },
    addtomarksheet() {
      const data = {
        lid: this.registration_no.registration_number,
        ay: this.sel_ay_data.ay_id,
      };
      axios
        .post("/ZealExamination/getStudentReportCard", data)
        .then((res) => {})
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {});
    },
    getreport() {
      localStorage.setItem("setay", this.sel_ay_data.ay_id);
      // localStorage.setItem("setsem", this.sem.id);
      localStorage.setItem(
        "setreg_no",
        this.registration_no.registration_number
      );
      this.show = true;
      console.log(this.registration_no);
      //   alert(this.registration_no.standard);
      //routing to secondary & primary report

      if (
        this.registration_no.standard == "IX" ||
        this.registration_no.standard == "X"
      ) {
        let routeData = this.$router.resolve({ name: "zeal-ms-secondary" });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({ name: "annual-ms" });
        window.open(routeData.href, "_blank");
        console.log(this.registration_no.standard);
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    getStud() {
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
    this.awspath = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
.text_report {
  border: 3px solid black;
  margin: 1rem !important;
}
thead {
  font-weight: bold !important;
}
th {
  font-weight: bold !important;
}
tr,
td,
th {
  border: 1px solid black;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid black;
  border: 1px solid black;
  font-size: small;
}
td {
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.delete-avatar {
  transition: 0.3s;
  border: 1px solid red;
  margin: 0.2rem !important;
}
.delete-avatar:hover {
  background-color: transparent;
}
.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}
.delete-v-icon:hover {
  color: white;
}
.v-dialogss {
  bottom: 880;
  right: 0;
}
@media print {
  .card {
    border: none !important;
    font-size: large !important;
  }
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  img {
    width: 100% !important;
  }
  body,
  tr,
  th,
  td {
    font-size: large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  thead {
    font-weight: bold !important;
  }
  table,
  td,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
ol.s {
  list-style-type: inherit;
}
</style>
